export const TASK_CATEGORY_DAILY = 1
export const TASK_CATEGORY_NEW_USER = 2

export const TASK_CATEGORY_OPTIONS = [
  { value: TASK_CATEGORY_DAILY, label: '日常任务' },
  { value: TASK_CATEGORY_NEW_USER, label: '新用户任务' }
]

export const TASK_TYPE_OPTIONS = [
  { value: 0, label: '开启推送', categories: [TASK_CATEGORY_DAILY] },
  { value: 1, label: '登录任意账号', categories: [TASK_CATEGORY_DAILY] },
  { value: 2, label: '关注Facebook', categories: [TASK_CATEGORY_DAILY] },
  { value: 3, label: '关注YouTube', categories: [TASK_CATEGORY_DAILY] },
  { value: 4, label: '关注TikTok', categories: [TASK_CATEGORY_DAILY] },
  { value: 5, label: '分享', categories: [TASK_CATEGORY_DAILY] },
  { value: 6, label: '每日看广告', categories: [TASK_CATEGORY_DAILY] },
  { value: 7, label: '观看3分钟', categories: [TASK_CATEGORY_DAILY] },
  { value: 8, label: '观看5分钟', categories: [TASK_CATEGORY_DAILY] },
  { value: 9, label: '观看15分钟', categories: [TASK_CATEGORY_DAILY] },
  { value: 10, label: '观看30分钟', categories: [TASK_CATEGORY_DAILY] },
  { value: 11, label: '签到', categories: [TASK_CATEGORY_DAILY] },
  { value: 12, label: '更新', categories: [TASK_CATEGORY_DAILY] },
  { value: 14, label: '每日H5广告', categories: [TASK_CATEGORY_DAILY] },
  { value: 15, label: '评分任务', categories: [TASK_CATEGORY_DAILY] }
]

export const AVAILABLE_LIMIT_OPTIONS = [
  { value: -1, label: '配置生效' },
  { value: 0, label: '不限次数' },
  { value: 1, label: '限一次' }
]

export const ACTIVITY_STATUS_OPTIONS = [
  { value: 1, label: '开启' },
  { value: 0, label: '关闭' }
]

export const SCORE_AUDIT_STATUS_OPTIONS = [
  { value: 0, label: '待审核' },
  { value: 1, label: '已通过' },
  { value: 2, label: '已拒绝' }
]

export const getTaskTypeOptionsByCategory = (taskCategory) =>
  TASK_TYPE_OPTIONS.filter((item) =>
    item.categories.includes(Number(taskCategory))
  )

export const getTaskTypeLabel = (activityType) => {
  const option = TASK_TYPE_OPTIONS.find(
    (item) => Number(item.value) === Number(activityType)
  )
  return option ? option.label : activityType
}

export const getAvailableLimitLabel = (value) => {
  const option = AVAILABLE_LIMIT_OPTIONS.find(
    (item) => Number(item.value) === Number(value)
  )
  return option ? option.label : value
}

export const getActivityStatusLabel = (value) => {
  const option = ACTIVITY_STATUS_OPTIONS.find(
    (item) => Number(item.value) === Number(value)
  )
  return option ? option.label : value
}

export const getScoreAuditStatusLabel = (value) => {
  const option = SCORE_AUDIT_STATUS_OPTIONS.find(
    (item) => Number(item.value) === Number(value)
  )
  return option ? option.label : value
}

export const inferTaskCategoryByType = (
  activityType,
  fallbackTaskCategory = TASK_CATEGORY_DAILY
) => {
  const option = TASK_TYPE_OPTIONS.find(
    (item) => Number(item.value) === Number(activityType)
  )
  return option && option.categories.length
    ? option.categories[0]
    : fallbackTaskCategory
}
